import angular from 'angular';

angular.module('cloudX').directive('validateNumberField', [
  '$window',
  'relBindSvc',
  function($window, relBindSvc) {
    return {
      restrict: 'A',
      require: ['ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        attributes.$observe('validateNumberField', function(value) {
          if (!value) return;
          var fieldDef = scope.$eval(value);
          if (!fieldDef || !fieldDef.validators || !fieldDef.validators.length) return;
          fieldDef.errors = {};
          var getFieldValue = function(field) {
            var relation = relBindSvc.relations[scope.relId];
            if (!relation || !relation[field]) return undefined;
            if (typeof relation[field].value !== 'undefined') return relation[field].value;
            return relation[field];
          };
          ngModel.$validators.number = function(modelValue) {
            if (modelValue === null) return true;
            return !isNaN(modelValue);
          };
          for (var i = 0; i < fieldDef.validators.length; i++) {
            var validator = fieldDef.validators[i];
            if (!validator) continue;
            if (validator.maximum !== null) {
              if ($window.isGuid(validator.maximum)) {
                if (bindErrors) bindErrors.addError('max', 24, [validator.maximum]);
                ngModel.$validators.max = (function(max) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    var other = getFieldValue(max);
                    if (typeof other === 'undefined' || other === null || isNaN(other)) return true;

                    if (Number(modelValue) <= Number(other)) return true;
                    return false;
                  };
                })(validator.maximum);
              } else {
                if (bindErrors)
                  bindErrors.addError(
                    'max',
                    6,
                    fieldDef.type === 41
                      ? [(validator.maximum * 100).toFixed(2) + '%']
                      : [validator.maximum],
                  );
                ngModel.$validators.max = (function(max) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    if (isNaN(modelValue)) return false;
                    if (Number(modelValue) <= Number(max)) return true;
                    fieldDef.errors.max = {
                      code: 6,
                      parameters: fieldDef.type === 41 ? [(max * 100).toFixed(2) + '%'] : [max],
                    };
                    return false;
                  };
                })(validator.maximum);
              }
            }
            if (validator.minimum !== null) {
              if ($window.isGuid(validator.minimum)) {
                if (bindErrors) bindErrors.addError('min', 24, [validator.minimum]);
                ngModel.$validators.min = (function(min) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    var other = getFieldValue(min);
                    if (typeof other === 'undefined' || other === null || isNaN(other)) return true;
                    if (Number(modelValue) >= Number(other)) return true;
                    fieldDef.errors.min = {
                      code: 24,
                      parameters: [min],
                    };
                    return false;
                  };
                })(validator.minimum);
              } else {
                if (bindErrors)
                  bindErrors.addError(
                    'min',
                    5,
                    fieldDef.type === 41
                      ? [(validator.minimum * 100).toFixed(2) + '%']
                      : [validator.minimum],
                  );
                ngModel.$validators.min = (function(min) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    if (isNaN(modelValue)) return false;
                    if (Number(modelValue) >= Number(min)) return true;
                    return false;
                  };
                })(validator.minimum);
              }
            }
          }
          //if (bindErrors) {
          //    ngModel.$viewChangeListeners.push(function () {
          //        bindErrors.refreshErrors(ngModel.$error);
          //    });
          //    scope.$on('$destroy', function () {
          //        bindErrors.refreshErrors();
          //    });
          //}
        });
      },
    };
  },
]);
